<template>
  <div class="timeline">

    <div class="future-step step md-layout" v-for="(step, index) in futureStepsReversed" :key="step.info.sid" @click="onStepClick(step)">
      <div class="image-wraper">
        <img :src="getFutureHubImage(index)" alt="Future Hub">
      </div>
      <div class="info-wraper">
        <div>
          <div class="md-body-1">{{ getFutureHubMessage(index) }}</div>
          <div v-if="lastEventOfStepBySid(step.info.sid)" class="hub-last-event">
            <div class="md-caption">{{ lastEventOfStepBySid(step.info.sid).date | formateDate }}</div>
            <div class="md-caption">{{ lastEventOfStepBySid(step.info.sid).label }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="current-step step md-layout" v-if="isCurrentStepHub" @click="onStepClick(packagePayload.currentStep)">
      <div class="image-wraper">
        <img :src="getCurrentHubImage()" alt="Current Hub">
      </div>
      <div class="info-wraper">
        <div>
          <div class="md-subheading">{{ $t('TIMELINE_EVENTS.IS_AT', { hubName: getHubName(packagePayload.currentStep) }) }}</div>
          <div v-if="lastEventOfStepBySid(packagePayload.currentStep.info.sid)" class="hub-last-event">
            <div class="md-caption">{{ lastEventOfStepBySid(packagePayload.currentStep.info.sid).date | formateDate }}</div>
            <div class="md-caption">{{ lastEventOfStepBySid(packagePayload.currentStep.info.sid).label }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="past-step step md-layout" v-for="(step, index) in previousStepsReversed" :key="step.info.sid" @click="onStepClick(step)">
      <div class="image-wraper">
        <img :src="getPreviousHubImage(index)" alt="Previous Hub">
      </div>
      <div class="info-wraper">
        <div>
          <div class="md-body-1">{{ $t('TIMELINE_EVENTS.WAS_AT', { hubName: getHubName(step) }) }}</div>
          <div v-if="lastEventOfStepBySid(step.info.sid)" class="hub-last-event">
            <div class="md-caption">{{ lastEventOfStepBySid(step.info.sid).date | formateDate }}</div>
            <div class="md-caption">{{ lastEventOfStepBySid(step.info.sid).label }}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import { PACKAGE_STATUS } from '@/configs/constants'

export default {
  name: 'TimeLine',
  computed: {
    ...mapState('package', [
      'packagePayload'
    ]),
    ...mapGetters('package', [
      'lastEventOfStepBySid'
    ]),
    futureStepsReversed () {
      return this.packagePayload.futureSteps.slice().reverse()
    },
    currentStep () {
      return this.packagePayload.currentStep
    },
    isCurrentStepHub () {
      return (this.packagePayload.currentStep && this.packagePayload.currentStep.info.type === 'HUB')
    },
    previousStepsReversed () {
      return this.packagePayload.previousSteps.slice().reverse()
    }
  },
  methods: {
    getHubName (step) {
      if (step && step.info) {
        return step.info.commercialLabel ? step.info.commercialLabel : step.info.name
      } else {
        return 'N/A'
      }
    },
    onStepClick (step) {
      this.$emit('hubClick', { step })
    },
    getFutureHubMessage (stepIndex) {
      let step = this.futureStepsReversed[stepIndex]
      return (this.packagePayload.statusLabel === PACKAGE_STATUS.IN_TRANSIT && stepIndex === (this.futureStepsReversed.length - 1))
        ? this.$t('TIMELINE_EVENTS.IN_TRANSIT_TO', { hubName: this.getHubName(step) })
        : this.$t('TIMELINE_EVENTS.WILL_BE_AT', { hubName: this.getHubName(step) })
    },
    getCurrentHubImage () {
      let image = null
      if (this.packagePayload.futureSteps.length <= 0 && this.packagePayload.previousSteps.length <= 0) {
        image = 'current_hub'
      } else if (this.packagePayload.futureSteps.length > 0 && this.packagePayload.previousSteps.length > 0) {
        image = 'current_hub_line_down_and_up'
      } else if (this.packagePayload.futureSteps.length <= 0) {
        image = 'current_hub_line_down'
      } else {
        image = 'current_hub_line_up'
      }
      return require(`@/assets/images/timeline/${image}.png`)
    },
    getPreviousHubImage (stepIndex) {
      let image = null
      if (this.previousStepsReversed.length === 1 && !this.hasCurrentStep() && !this.hasFutureSteps()) {
        image = 'previous_hub'
      } else if (stepIndex === (this.previousStepsReversed.length - 1)) {
        image = 'previous_hub_line_up'
      } else if (!this.hasCurrentStep() && !this.hasFutureSteps() && stepIndex === 0) {
        image = 'previous_hub_line_down'
      } else {
        image = 'previous_hub_line_up_and_down'
      }
      return require(`@/assets/images/timeline/${image}.png`)
    },
    getFutureHubImage (stepIndex) {
      let image = null
      if (this.futureStepsReversed.length === 1 && !this.hasCurrentStep() && !this.hasPreviousSteps()) {
        image = 'future_hub'
      } else if (stepIndex === 0) {
        image = 'future_hub_line_down'
      } else if (!this.hasCurrentStep() && !this.hasPreviousSteps() && stepIndex === (this.futureStepsReversed.length - 1)) {
        image = 'future_hub_line_up'
      } else {
        image = 'future_hub_line_down_and_up'
      }
      return require(`@/assets/images/timeline/${image}.png`)
    },
    hasCurrentStep () {
      return this.packagePayload.currentStep &&
        this.packagePayload.currentStep.info &&
        this.packagePayload.currentStep.info.sid !== 'TARGET' &&
        this.packagePayload.currentStep.info.sid !== 'ORIGIN'
    },
    hasPreviousSteps () {
      return this.packagePayload.previousSteps && this.packagePayload.previousSteps.length > 0
    },
    hasFutureSteps () {
      return this.packagePayload.futureSteps && this.packagePayload.futureSteps.length > 0
    }
  },
  filters: {
    formateDate: function (value) {
      if (value) {
        return moment(value).format('HH:mm, DD/MM/YYYY')
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.step
  height: 100px
  border-radius: 10px
  &:hover
    cursor: pointer
    background-color: rgba(255, 230, 179, 0.7)
    transition: all linear 0.4s
  .image-wraper
    display: flex
    justify-content: center
    align-items: center
    align-content: center
    width: 100px
    height: 100px
  .info-wraper
    width: calc(100% - 100px)
    display: flex
    align-items: center

</style>
